import { Button } from 'react-bootstrap';
import React from 'react';

const EmployeeRow = ({ employee, handleRemove }) => {
  return (
    <div key={`employee${employee.id}`} className="flex m-b-16">
      <div className="flex-1">
        <div className="form-group m-b-0">
          <input
            className="form-control"
            value={`${employee.fullName} ${employee.archived ? '(archived)' : ''} `}
            disabled
          />
        </div>
      </div>
      <Button
        className="btn-delete m-l-8"
        onClick={() => handleRemove(employee)}
      >
        Delete
      </Button>
    </div>
  );
};

export default EmployeeRow;
